export enum SERVICE_PAYMENT_TYPE {
  cashOnSite = 'PAID_BY_CASH_ON_SITE',
  card = 'PAID_BY_CARD',
  store = 'PAID_IN_STORE',
  balance = 'PAID_BY_BALANCE',
}
export enum SERVICE_PAYMENT_TYPE_FILTER {
  cashOnSite = 'PAID_BY_CASH_ON_SITE',
  card = 'PAID_BY_CARD',
  store = 'PAID_IN_STORE',
  balance = 'PAID_BY_BALANCE',
  free = 'FREE',
}

/** Нужно, чтобы менеджить форму оплаты, используется совместно с SERVICE_PAYMENT_TYPE */
export const SERVICE_UNPAY_TYPE = 'unpay';
export type SERVICE_EDIT_METHOD_TYPE = SERVICE_PAYMENT_TYPE | typeof SERVICE_UNPAY_TYPE;